import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export interface DoubtfulDebtReserveItem {
  id?: string;
  line_number: number;
  contractor_id: string;
  contract_id: string;
  debt_account_code: string;
  debt_amount: string;
  reserve_percent: string;
  reserve_amount: string;
}

export interface DoubtfulDebtReserveListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
  // Block 5.3f:
  state?: CancellableState;
}

export interface DoubtfulDebtReserve extends DoubtfulDebtReserveListItem {
  calculation_method: string;
  expense_account_code: string;
  reserve_account_code: string;
  posted_at: string | null;
  comment: string | null;
  items: DoubtfulDebtReserveItem[];
  // Block 5.3f:
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface DoubtfulDebtReserveCreate {
  organization_id: string;
  document_number: string;
  document_date: string;
  calculation_method?: string;
  expense_account_code?: string;
  reserve_account_code?: string;
  comment?: string | null;
  items: DoubtfulDebtReserveItem[];
}

export type DoubtfulDebtReserveUpdate = Partial<DoubtfulDebtReserveCreate>;

export const doubtfulDebtReserves = {
  list: (params?: { organization_id?: string; posted?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<DoubtfulDebtReserveListItem>>('/doubtful-debt-reserves', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<DoubtfulDebtReserve>(`/doubtful-debt-reserves/${id}`).then((r) => r.data),
  create: (payload: DoubtfulDebtReserveCreate) =>
    api.post<DoubtfulDebtReserve>('/doubtful-debt-reserves', payload).then((r) => r.data),
  update: (id: string, payload: DoubtfulDebtReserveUpdate) =>
    api.patch<DoubtfulDebtReserve>(`/doubtful-debt-reserves/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/doubtful-debt-reserves/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<DoubtfulDebtReserve>(`/doubtful-debt-reserves/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<DoubtfulDebtReserve>(`/doubtful-debt-reserves/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/doubtful-debt-reserves/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
